import { MdCall, MdTimer } from "react-icons/md"
import { FaMapMarkerAlt } from "react-icons/fa"
import { useState } from "react"
import { Stepper, Step, StepLabel, StepConnector, Box, StepContent, stepConnectorClasses } from '@mui/material';
import { styled } from '@mui/system';
const CustomStepConnector = styled(StepConnector)(({}) => ({
    '&.MuiStepConnector-root': {
      top: 5,
    },
    '& .MuiStepConnector-line': {
        borderWidth: 3, 
        minHeight: 56,  //height of the connector
        // borderColor: stepState === 'active' || stepState === 'completed' ? '#3b939e' : '#B5C7C9',    
    },
    [`&.${stepConnectorClasses.active}`]: {
        '& .MuiStepConnector-line': {
          borderColor: '#3b939e',
        },
    },  
    [`&.${stepConnectorClasses.completed}`]: {
    '& .MuiStepConnector-line': {
        borderColor: '#3b939e',
    },
    },
  }));
  const CustomStepConnector2 = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: `calc(-50% + 12px)`,
      right: `calc(50% + 12px)`,
    },
    [`&.${stepConnectorClasses.active}`]: {
      '& .MuiStepConnector-line': {
        borderColor: '#3b939e', // Color for active connector
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      '& .MuiStepConnector-line': {
        borderColor: '#3b939e', // Color for completed connector
      },
    },
    [`& .MuiStepConnector-line`]: {
      borderWidth: 3,
      width: '100%', // For horizontal stepper, width is important
      borderColor: '#B5C7C9', // Default color for inactive connector
    },
  }));

const EmptyStepIcon = styled('div')(({active, completed}) => ({
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: active || completed ? '#3b939e' : '#ffffff', 
    border: `3px solid ${active || completed ? '#3b939e' : '#DAEBED'}`,
    boxShadow: active || completed ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
}));
  
const Infobox = (props) => {
    const [showMap, setShowMap] = useState(false)
    const [current, setCurrent] = useState(false)
    const steps = ['Choose Ticket', 'Customer Details', 'Confirmation'];
    const activeStep = props.step - 1;
    console.log('active step', activeStep - 1)
    return (
        <div className="text-center mt-3">
            <div className="d-none d-md-block">
                <Box sx={{ margin: '0 auto' }}>
                    <Stepper
                        activeStep={activeStep}
                        orientation="vertical"
                        connector={<CustomStepConnector/>}
                    >
                        {steps.map((label, index) => (
                        <Step key={label} completed={activeStep > index}>
                            <StepLabel
                                StepIconComponent={(props) => (
                                    <EmptyStepIcon {...props} active={activeStep === index} completed={activeStep > index} />
                                )}
                                sx={{
                                padding: 0,
                                '& .MuiStepLabel-label.Mui-active': {
                                    color: '#3b939e', // Active step label color
                                },
                                '& .MuiStepLabel-label.Mui-completed': {
                                    color: '#3b939e', // Completed step label color
                                },
                                '& .MuiStepLabel-label': {
                                    color: '#000', // Default color for non-active steps
                                },
                                '& .MuiStepLabel-iconContainer': {
                                    paddingRight: '16px', // Adjust padding-right for icon container
                                },
                            }}
                            >
                            <div className="text-montserrat mb-0 whitespace-nowrap">{label}</div>
                            </StepLabel>
                        </Step>                    
                        ))}
                    </Stepper>
                </Box>
            </div>
            <div className="d-block d-md-none">
            <Box sx={{ width: '100%' }}> {/* Adjust width for horizontal layout */}
                <Stepper
                activeStep={activeStep}
                orientation="horizontal" // Set orientation to horizontal
                alternativeLabel
                connector={<CustomStepConnector2 />} // Custom connector
                >
                {steps.map((label, index) => (
                    <Step key={label} completed={activeStep > index}>
                    <StepLabel
                        StepIconComponent={(props) => (
                        <EmptyStepIcon
                            {...props}
                            active={activeStep === index}
                            completed={activeStep > index}
                        />
                        )}
                        sx={{
                        padding: 0,
                        '& .MuiStepLabel-label.Mui-active': {
                            color: '#3b939e', // Active step label color
                        },
                        '& .MuiStepLabel-label.Mui-completed': {
                            color: '#3b939e', // Completed step label color
                        },
                        '& .MuiStepLabel-label': {
                            color: '#000', // Default color for non-active steps
                        },
                        }}
                    >
                        <div className="text-montserrat mb-0">{label}</div>
                    </StepLabel>
                    </Step>
                ))}
                </Stepper>
            </Box>
            </div>
            {/* <div className='mb-4'>
                <h6><b>Available Payment Options</b></h6>
                <div className="aval-pay-w">
                {paymentMethod.map((elem,index)=>(
                    <img key={index} src={elem.imgUrl} alt={elem.name} className='img-fluid pay-img m-1' />
                ))}
                </div>
            </div> */}
            {/* <div className="dotted-hr my-3"></div> */}
            {/* <MdTimer className="lg-icon" /> */}
            {/* <h6><b>Contact Us</b></h6>
            <a onClick={()=>setShowMap(true)} className="support-link sm-text_" title="Click to view map"> 
                <FaMapMarkerAlt /> Butwal, Nepal
            </a>
            <div className="mt-1 mb-2 sm-text_">
                <a href="tel:9814415613" className="support-link" title="Call to 9814415613"> 
                    <MdCall /> 9814415613
                </a>
            </div> */}
            <div>
                {/* <div>
                    <b>Ticket Counter  </b> <br/> <span className="sm-text_"> 10 AM to 5 PM </span>
                </div> */}
                {/* <div className="my-2">
                    <b>Cable Car </b> <br/>  <span className="sm-text_">11 AM to 6 PM</span>
                </div>
                <div>
                    <b>Lunch break </b> <br/>  <span className="sm-text_">1 PM to 2 PM </span>
                </div> */}
            </div>
            <div className={showMap ? 'modal my-modal fade show' : 'modal my-modal fade'} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"><FaMapMarkerAlt /> Siddhartha Cable Car</h5>
                            <button type="button" className="btn-close" 
                                onClick={()=>setShowMap(false)}
                                aria-label="Close"></button>
                        </div>
                        
                        <div className="modal-body">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.6820316621565!2d83.46210720565516!3d27.710205946958865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3996871ce57c5caf%3A0x3d14e044e0b8b7d4!2sSiddhartha%20Cable%20Car%20Lower%20Station!5e0!3m2!1sen!2snp!4v1706859521824!5m2!1sen!2snp" 
                            width="100%" height="400" style={{'border':'1px solid #ddd'}} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
            </div>                
            {/* <p>
                <b>Saturday - Sunday <br /></b>
                    Public Holidays <br />
            </p>
            <div className="dotted-hr my-3"></div>
            <h6><b>For technical support: </b></h6>
            <div>
                <a href="tel:071-534663" className="support-link" title="Call to 071-534663"> 
                    <MdCall /> 071-534663
                </a>
            </div>
            <div>
                <a href="whatsapp://71-534663" target="_blank" className="support-link" title="Whatsapp call to 071-534663">
                    <FaWhatsapp /> 071-534663
                </a>
            </div>
            <div className="dotted-hr my-3"></div>
            <h6 className="mt-3"><b>How to reach</b></h6>
            <div className="w-100">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2885.6820316621565!2d83.46210720565516!3d27.710205946958865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3996871ce57c5caf%3A0x3d14e044e0b8b7d4!2sSiddhartha%20Cable%20Car%20Lower%20Station!5e0!3m2!1sen!2snp!4v1706859521824!5m2!1sen!2snp" 
                width="100%" height="300" style={{'border':'1px solid #ddd'}} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div> */}
        </div>
    )
}

export default Infobox